import React, { useState, useEffect } from 'react';
import { 
  collection, 
  deleteDoc, 
  updateDoc, 
  doc, 
  setDoc, // addDoc yerine setDoc kullanacağız
  onSnapshot, 
  query, 
  orderBy, 
  serverTimestamp 
} from 'firebase/firestore';
import { 
  ref, 
  uploadBytes, 
  getDownloadURL 
} from 'firebase/storage';
import { db, storage } from '../firebase/firebase-config';
import './Articles.css';

// --- SEO DOSTU ID (SLUG) OLUŞTURUCU ---
const createSlug = (text) => {
  const trMap = {
    'ç': 'c', 'ğ': 'g', 'ş': 's', 'ü': 'u', 'i': 'i', 'ı': 'i', 'ö': 'o',
    'Ç': 'C', 'Ğ': 'G', 'Ş': 'S', 'Ü': 'U', 'İ': 'I', 'Ö': 'O'
  };
  for (let key in trMap) {
    text = text.replace(new RegExp(key, 'g'), trMap[key]);
  }
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Alfanümerik olmayanları siler
    .replace(/[\s_-]+/g, '-')  // Boşlukları tireye çevirir
    .replace(/^-+|-+$/g, '');  // Kenar tirelerini temizler
};

// --- MODAL COMPONENT ---
const ArticleModal = ({ isOpen, onClose, onSave, article }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: 'Hukuk',
    summary: '',
      metaDescription: '',

    content: '',
    imageUrl: ''
  });
  
  const [imageUpload, setImageUpload] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (article) {
      setFormData(article);
      setImageUpload(null);
    } else {
      setFormData({
        title: '',
        category: 'Hukuk',
        summary: '',
          metaDescription: '',

        content: '',
        imageUrl: ''
      });
      setImageUpload(null);
    }
  }, [article, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    let finalImageUrl = formData.imageUrl;

    if (imageUpload) {
      try {
        const imageRef = ref(storage, `article-images/${Date.now()}-${imageUpload.name}`);
        const snapshot = await uploadBytes(imageRef, imageUpload);
        finalImageUrl = await getDownloadURL(snapshot.ref);
      } catch (error) {
        console.error("Resim yükleme hatası:", error);
        alert("Resim yüklenirken bir hata oluştu!");
        setUploading(false);
        return;
      }
    }

    await onSave({ ...formData, imageUrl: finalImageUrl });
    setUploading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{article ? 'Makaleyi Düzenle' : 'Yeni Makale Ekle'}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Makale Başlığı (URL buna göre oluşur)</label>
            <input 
              type="text" 
              value={formData.title} 
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required 
              placeholder="Örn: Ankara Ceza Avukatı"
            />
          </div>

          

          <div className="form-group">
            <label>Kategori</label>
            <select 
              value={formData.category} 
              onChange={(e) => setFormData({...formData, category: e.target.value})}
            >
              <option value="Hukuk">Genel Hukuk</option>
              <option value="Aile Hukuku">Aile Hukuku</option>
              <option value="Ceza Hukuku">Ceza Hukuku</option>
              <option value="İş Hukuku">İş Hukuku</option>
              <option value="Arabuluculuk">Arabuluculuk</option>
            </select>
          </div>

          <div className="form-group">
            <label>Makale Görseli</label>
            {formData.imageUrl && !imageUpload && (
              <div style={{marginBottom: '10px'}}>
                 <img src={formData.imageUrl} alt="Mevcut" style={{width: '100px', height: '60px', objectFit:'cover', borderRadius:'4px'}} />
              </div>
            )}
            <input 
              type="file" 
              accept="image/*" 
              onChange={(e) => setImageUpload(e.target.files[0])}
            />
          </div>

          <div className="form-group">
            <label>Kısa Özet</label>
            <textarea 
              style={{ height: '80px' }}
              value={formData.summary} 
              onChange={(e) => setFormData({...formData, summary: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
  <label>Meta Açıklama (SEO)</label>
  <textarea
    style={{ height: '80px' }}
    maxLength={160}
    value={formData.metaDescription || ''}
    onChange={(e) =>
      setFormData({
        ...formData,
        metaDescription: e.target.value
      })
    }
    placeholder="Google sonuçlarında görünecek açıklama (150-160 karakter)"
  />
</div>

          

          <div className="form-group">
            <label>İçerik</label>
            <textarea 
              value={formData.content} 
              onChange={(e) => setFormData({...formData, content: e.target.value})}
              required
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="cancel-btn" onClick={onClose}>İptal</button>
            <button type="submit" className="save-btn" disabled={uploading}>
              {uploading ? 'Yükleniyor...' : 'SEO Dostu Kaydet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// --- MAIN ARTICLES PAGE ---
const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingArticle, setEditingArticle] = useState(null);

  useEffect(() => {
    const articlesRef = collection(db, 'articles');
    const q = query(articlesRef, orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const articlesData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setArticles(articlesData);
    });

    return () => unsubscribe();
  }, []);

  const handleSave = async (formData) => {
    try {
      if (editingArticle) {
        // GÜNCELLEME: ID değişmez
        const articleDocRef = doc(db, 'articles', editingArticle.id);
        await updateDoc(articleDocRef, {
          ...formData,
          updatedAt: serverTimestamp()
        });
      } else {
        // YENİ EKLEME: ID'yi manuel veriyoruz ✅
        const slug = createSlug(formData.title); 
        const newArticleRef = doc(db, 'articles', slug);
        
        await setDoc(newArticleRef, {
          ...formData,
          slug: slug,
          createdAt: serverTimestamp()
        });
      }
      
      setIsModalOpen(false);
      setEditingArticle(null);
    } catch (error) {
      console.error("Hata:", error);
      alert("Hata oluştu: " + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu makaleyi silmek istediğinize emin misiniz?")) {
      try {
        await deleteDoc(doc(db, 'articles', id));
      } catch (error) {
        console.error("Silme hatası:", error);
      }
    }
  };

  return (
    <div className="articles-container">
      <div className="page-header">
        <div>
          <h2>Makaleler</h2>
          <p style={{color: '#666', fontSize: '14px', marginTop: '5px'}}>
            Blog yazılarını SEO dostu URL yapısıyla buradan yönetebilirsiniz.
          </p>
        </div>
        <button className="add-btn" onClick={() => { setEditingArticle(null); setIsModalOpen(true); }}>
          <span>+</span> Yeni Makale Ekle
        </button>
      </div>

      <div className="table-container">
        <table className="articles-table">
          <thead>
            <tr>
              <th style={{width: '80px'}}>Görsel</th>
              <th>Başlık / URL</th>
              <th>Kategori</th>
              <th>Tarih</th>
              <th style={{textAlign: 'right'}}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.id}>
                <td>
                  <img src={article.imageUrl} alt="Makale" style={{width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px'}} />
                </td>
                <td>
                  <strong style={{display:'block', color:'#333'}}>{article.title}</strong>
                  <code style={{fontSize:'11px', color:'#007bff'}}>/makaleler/{article.id}</code>
                </td>
                <td><span className="status-badge">{article.category}</span></td>
                <td>{article.createdAt?.seconds ? new Date(article.createdAt.seconds * 1000).toLocaleDateString('tr-TR') : '-'}</td>
                <td style={{textAlign: 'right'}}>
                  <button className="action-btn edit-btn" onClick={() => { setEditingArticle(article); setIsModalOpen(true); }}>Düzenle</button>
                  <button className="action-btn delete-btn" onClick={() => handleDelete(article.id)}>Sil</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ArticleModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        article={editingArticle}
      />
    </div>
  );
};

export default Articles;